var React = require('react');

function Boost (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M19.806,0.561c-0.086-0.206-0.282-0.339-0.5-0.346L13.357,0c-0.94,0-1.204,0.104-1.73,0.757L1.248,14.614   c-0.122,0.169-0.148,0.395-0.055,0.585c0.101,0.187,0.289,0.306,0.5,0.307l5.584,0.019c1.175,0.006,1.611,0.816,0.967,1.8   L0.09,29.793c-0.154,0.244-0.107,0.564,0.123,0.746c0.107,0.084,0.238,0.121,0.369,0.115c0.133-0.006,0.274-0.068,0.378-0.176   l17.884-18.805c0.153-0.162,0.191-0.396,0.105-0.604c-0.085-0.205-0.28-0.331-0.502-0.333l-2.886-0.009l-2.772-0.01   c-1.158-0.013-1.454-0.711-0.653-1.562l7.559-8C19.844,0.998,19.887,0.756,19.806,0.561z"})));
}

Boost.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 19.846 19.846","style":{"enableBackground":"new 0 0 19.846 30.655"},"xmlSpace":"preserve"};

module.exports = Boost;

Boost.default = Boost;
